import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { CostCenter } from '../_types/costCenter';
import { CostCentersService } from '../_services/costsCenters.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-costs-centers-detail',
    templateUrl: './costs-centers-detail.component.html',
    styleUrls: ['./costs-centers-detail.component.css'],
    standalone: false
})
export class CostsCentersDetailComponent implements OnInit {

   public costCenterFormGroup!: RxFormGroup;
    public costCenter: CostCenter = new CostCenter();  
    public allowWrite: boolean = false;
    public allowDelete: boolean = false;

  constructor(
    private costCentersService: CostCentersService,
        private config: DynamicDialogConfig,
        private dynamicDialogRef: DynamicDialogRef,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private formBuilder: RxFormBuilder,
        private formValidationService: FormValidatorService,
        private loginService: LoginService
  ) { 
        this.costCenterFormGroup = this.formBuilder.formGroup<CostCenter>(this.costCenter) as RxFormGroup;
    
  }

  ngOnInit() {
    let id = this.config.data.id;
    if(id){
      this.loadData(id);
    }
    this.allowWrite = this.loginService.hasPermission("COSTS_CENTERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("COSTS_CENTERS.DELETE");
  }


    async loadData(id: string) {
      this.costCenter = await firstValueFrom(this.costCentersService.get(id));
      this.costCenterFormGroup.patchValue(this.costCenter);
    }
  
    cancel() {
      this.dynamicDialogRef.close();
    }
  
    
    async save() {
      let valid = this.formValidationService.validateForm(this.costCenterFormGroup);
      if (valid) {
        this.costCenter = Object.assign(this.costCenter, this.costCenterFormGroup.value);
        let mailAccountsService = await firstValueFrom(this.costCentersService.save(this.costCenter));
  
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Centro de coste guardado correctamente." });
        this.dynamicDialogRef.close();
  
      } else {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
      }
    }

    
  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea el centro de coste?",
      header: "Eliminar centro de coste",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.costCentersService.delete(this.costCenter.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Centro de coste eliminado correctamente." });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

}
